/**
 * Checks if a given HTML element is the direct row or cell to a specific HTML table.
 *
 * @param table - The HTMLTableElement to check against.
 * @param element - The element to verify.
 * @returns A boolean indicating whether the element belongs to the table.
 */
export const isDirectDescendantOfTable = (table: HTMLTableElement, element: unknown) => {
	const rows = Array.from(table.rows);

	if (element instanceof HTMLTableRowElement) {
		return rows.some((row) => row === element);
	}

	if (element instanceof HTMLTableCellElement) {
		return rows.some((row) => row === element.parentElement);
	}

	return false;
};
